import { Flex, Heading, LinkButton } from "@hopper-ui/components";
import { Routes, SmartReportsListEmptyStateIllustration, useSharedTranslation } from "@workleap-ai/shared";

export const SmartReportsListEmptyState = () => {
    const { tShared } = useSharedTranslation();

    return (
        <Flex
            grow={1}
            width="100%"
            direction="column"
            alignItems="center"
            justifyContent="center"
            gap="stack-xl"
            textAlign="center"
            padding="inset-lg"
        >
            <SmartReportsListEmptyStateIllustration />
            <Heading>{tShared("smartReports.emptyState")}</Heading>
            <LinkButton variant="secondary" href={Routes.Home()}>{tShared("smartReports.backToHome")}</LinkButton>
        </Flex>
    );
};
